import { Image, Text } from '@capsicum/common-web';
import { styled } from 'styled-components';

export const TabContentContainer = styled.div`
	margin-top: ${({ theme }) => theme.spacings.xlarge};
	/* TODO: Move padding to MaxWidthContainer in WCPledge.tsx once confirmed with design */
	padding: 0 ${({ theme }) => theme.spacings.small};
	height: 100%;
`;

export const ListContainer = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-flow: column;
	gap: ${({ theme }) => theme.spacings.medium};
	margin-top: ${({ theme }) => theme.spacings.small};
	margin-bottom: ${({ theme }) => theme.spacings.medium};
`;

export const Title = styled(Text)`
	margin-bottom: ${({ theme }) => theme.spacings.medium};
`;

export const Subtitle = styled(Text)`
	margin-bottom: ${({ theme }) => theme.spacings.small};
`;

export const PointTitle = styled(Text)`
	margin-bottom: ${({ theme }) => theme.spacings.xxsmall};
`;

export const ImageWrapper = styled.div`
	width: 64px;
`;

export const PointImage = styled(Image)`
	width: 100%;
	height: 100%;
	object-fit: contain;
`;

export const Section = styled.div`
	background-color: ${({ theme }) => theme.colors.backgrounds.main.container};
	border-radius: ${({ theme }) => theme.sizing.xxxsmall};
	padding: ${({ theme }) => theme.spacings.medium};
	margin-bottom: ${({ theme }) => theme.spacings.medium};
`;

export const SubSection = styled.div`
	background-color: ${({ theme }) => theme.colors.backgrounds.info.subtle};
	border-radius: ${({ theme }) => theme.sizing.xxxsmall};
	padding: ${({ theme }) => theme.spacings.medium};
	margin-bottom: ${({ theme }) => theme.spacings.xxsmall};
	display: flex;
	flex-flow: row;
	align-items: center;
	justify-content: space-between;
	gap: ${({ theme }) => theme.spacings.medium};
`;

export const List = styled.ul`
	margin: 0;
	padding: 0;
	padding-left: ${({ theme }) => theme.spacings.large};
`;
export const FaqAnswer = styled(Text)`
	padding-top: ${({ theme }) => theme.spacings.medium};
	white-space: pre-wrap;
`;

export const Link = styled.a`
	color: ${({ theme }) => theme.colors.text.brand.enabled};
	${({ theme }) => theme.fonts.text.text3};
	text-decoration: none;
`;
